import * as R from 'ramda';

import { DetailTabItem } from '@atom/components/common/detailTabBar/DetailTabBar';
import {
  DescriptionIcon,
  FolderIcon,
  InfoIcon,
  InsertPhotoIcon,
  ListIcon,
  MonetizationOnIcon,
  WorkIcon,
} from '@atom/mui/icons';
import { AssetDetail, AssetDetailView } from '@atom/types/asset';
import {
  isMaterialAssetRequestsEnabled,
  isStockBasedAssetRequestsEnabled,
} from '@atom/utilities/tenantFeatureUtilities';

export const getViews = (asset: AssetDetail): DetailTabItem[] => {
  const isMaterial = !!R.pathOr(false, ['isMaterial'], asset);
  const isStockBased = !!R.pathOr(false, ['budget', 'isStockBased'], asset);

  const showAssetRequests =
    (isStockBasedAssetRequestsEnabled && isStockBased) ||
    (isMaterialAssetRequestsEnabled && isMaterial);

  return [
    {
      value: AssetDetailView.ASSET_INFO,
      label: 'info',
      icon: InfoIcon,
      dataCy: 'assetInfoTab',
    },
    {
      value: AssetDetailView.SUB_ITEMS,
      label: 'sub items',
      icon: ListIcon,
      dataCy: 'assetSubItemsTab',
    },
    {
      value: AssetDetailView.WORK,
      label: 'work',
      icon: WorkIcon,
      dataCy: 'assetWorkTab',
    },
    ...(showAssetRequests
      ? [
          {
            value: AssetDetailView.REQUESTS,
            label: 'requests',
            icon: DescriptionIcon,
            dataCy: 'assetRequestsTab',
          },
        ]
      : []),
    {
      value: AssetDetailView.FILES,
      label: 'files',
      icon: FolderIcon,
      dataCy: 'assetFilesTab',
    },
    {
      value: AssetDetailView.PHOTOS,
      label: 'photos',
      icon: InsertPhotoIcon,
      dataCy: 'assetPhotosTab',
    },
    ...(isMaterial
      ? [
          {
            value: AssetDetailView.COST,
            label: 'cost',
            icon: MonetizationOnIcon,
            dataCy: 'assetCostTab',
          },
        ]
      : []),
  ];
};
